import { Injectable, Type } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DialogService<T, D> {
  dialogRef?: MatDialogRef<T>;

  constructor(private dialog: MatDialog) {}

  public open(type: Type<T>, data?: any, config?: MatDialogConfig): void {
    this.dialogRef = this.dialog.open(type, {
      data,
      ...config,
    });
  }

  public confirmed(): Observable<D> {
    return (
      this.dialogRef?.afterClosed().pipe(
        take(1),
        map((res) => {
          return res;
        }),
      ) ?? of(null)
    );
  }
}
